import { Component, Input } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';

interface CheckVerificationRow {
  numeroAssegno: string;
  verificato?: boolean;
  selezionato?: boolean;
  selezionaAssegno?: (checked: boolean) => void;
}

@Component({
  selector: 'rev-receipts-check-verification-cell',
  imports: [MatCheckboxModule],
  template: `
    @if (itemData.verificato) {
      <i
        class="fa-regular fa-check check-verified-icon"
        [attr.aria-label]="'Assegno ' + itemData.numeroAssegno + ' verificato'"
      ></i>
    } @else {
      <mat-checkbox
        [checked]="itemData.selezionato ?? false"
        [attr.aria-label]="'Verifica assegno ' + itemData.numeroAssegno"
        (change)="seleziona($event.checked)"
        (click)="$event.stopPropagation()"
      />
    }
  `,
  styles: `
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .check-verified-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      color: var(--mat-sys-success);
      font-size: 24px;
      line-height: 24px;
    }
  `,
})
export class receiptsCheckVerificationCell {
  @Input({ required: true }) itemData!: CheckVerificationRow;
  @Input() infoColumn: unknown;
  @Input() _reloadData?: { emit: () => void };

  seleziona(checked: boolean): void {
    this.itemData.selezionato = checked;
    this.itemData.selezionaAssegno?.(checked);
  }
}
